import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Layout } from '@utilities';

import NoDataPlaceholder from '../NoDataPlaceholder';
import OpenEndedTable from './components/OpenEndedTable';

const OpenEnded = ({ data, getResponseTextSummary, question }) => {
  if (!data?.segments?.length) return <NoDataPlaceholder />;

  return (
    <Layout.Flex.Column>
      {data.segments.map((segment) => (
        <Fragment key={segment.id}>
          {getResponseTextSummary({ question, segment })}
          <OpenEndedTable columns={segment.table.columns} data={segment.table.data} />
        </Fragment>
      ))}
    </Layout.Flex.Column>
  );
};

OpenEnded.propTypes = {
  data: PropTypes.object,
  getResponseTextSummary: PropTypes.func,
  question: PropTypes.object,
};

export default OpenEnded;
